import { getAccentColor } from '../lib/theme';

export function getArchimageModalProps() {
  const c = getAccentColor();
  return {
    withCloseButton: false,
    closeOnClickOutside: false,
    closeOnEscape: false,
    centered: true,
    styles: {
      header: {
        backgroundColor: `var(--mantine-color-${c}-0)`,
        borderBottom: `1px solid var(--mantine-color-${c}-2)`,
        paddingTop: 10,
        paddingBottom: 10,
        minHeight: 'auto',
      },
      title: {
        fontSize: 'var(--mantine-font-size-md)',
        fontWeight: 600,
        lineHeight: 1.25,
        color: `var(--mantine-color-${c}-9)`,
      },
      body: {
        paddingTop: 'var(--mantine-spacing-md)',
        paddingBottom: 'var(--mantine-spacing-md)',
      },
    },
  };
}

export function blockModalEnterKey(e) {
  if (e.key === 'Enter') {
    e.preventDefault();
  }
}

export function generateEphemeralCode() {
  return String(Math.floor(100000 + Math.random() * 900000));
}
